import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchySelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchy.select(
    {},
  );
